import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default ApplicationSerializer.extend({});